import { Directive, OnInit, EventEmitter, Output, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { SortService } from './sortable-column.service';

@Directive({
  selector: '[sortable-table]',
  standalone: false,
})
export class SortableTableDirective implements OnInit, OnDestroy {
  constructor(private sortService: SortService) {}

  @Output()
  sorted = new EventEmitter();

  private columnSortedSubscription: Subscription;

  ngOnInit() {
    this.columnSortedSubscription = this.sortService.columnSorted$.subscribe((event) => {
      this.sorted.emit(event);
    });
  }

  ngOnDestroy() {
    if (!this.columnSortedSubscription) {
      return;
    }

    this.columnSortedSubscription.unsubscribe();
  }
}
